import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnpin: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconUnpin"><Path d="M15.8615 16.9222L21.25 22.3107L22.3107 21.25L2.74999 1.68933L1.68933 2.74999L7.07773 8.13839L2.35217 9.66277L7.81432 15.1249L2.68932 20.2499L3.74998 21.3106L8.87498 16.1856L14.3371 21.6477L15.8615 16.9222Z" fill="currentColor"/><Path d="M17.1303 12.9889L16.8667 13.806L10.1939 7.13319L11.011 6.86959L14.3669 1.55615L22.4437 9.63302L17.1303 12.9889Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnpin;
